






































import {AttachmentUploadStarted, AttachmentWasUploaded} from '@/components/estimates/common/controls/events';
import AttachmentControl from '@/components/estimates/expertEstimate/AttachmentControl.vue';
import AttachmentUpload from '@/components/estimates/expertEstimate/AttachmentUpload.vue';
import {Attachment, AttachmentType} from '@/model/api';
import ExpertEstimate from '@/model/estimates/ExpertEstimate';
import {blobToDataURL} from 'blob-util';
import {Component, Inject, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {
    AttachmentControl,
    AttachmentUpload,
  },
})
export default class AttachmentTypeControl extends Vue {
    @Inject()
    public readonly model: ExpertEstimate;

    @Prop({type: String, required: true})
    public readonly attachmentType: AttachmentType;

    @Prop({type: Boolean, required: true})
    public readonly checked: boolean;

    @Prop({type: Array, required: true})
    public readonly attachments: Attachment[];

    private runningUploads: {[uploadId: string]: string} = {};

    private uploadedAttachments: Attachment[] = [...this.attachments];

    private isAttachmentTypeSelected: boolean = this.checked;

    get attachmentTypeModel(): boolean {
        return this.isAttachmentTypeSelected;
    }

    set attachmentTypeModel(value: boolean) {
        this.handleAttachmentTypeChange(value);
        this.isAttachmentTypeSelected = value;
    }

    public uploadStarted(event: AttachmentUploadStarted): void {
        blobToDataURL(event.file)
            .then(dataUri => {
                this.runningUploads = {...this.runningUploads, [event.uploadId]: dataUri};
            });
    }

    public uploadFinished(event: AttachmentWasUploaded): void {
        this.uploadedAttachments.push(event);

        this.$delete(this.runningUploads, event.uploadId);

        if (Object.keys(this.runningUploads).length === 0) {
            this.refresh();
        }

        this.$emit('changed');
    }

    public attachmentRemoved(removedAttachment: Attachment): void {
        this.uploadedAttachments = this.uploadedAttachments
            .filter(attachment => attachment.id !== removedAttachment.id);

        this.$emit('changed');
    }

    private handleAttachmentTypeChange(isChecked: boolean): void {
        if (isChecked) {
            this.model.addAttachmentType(this.attachmentType)
                .then(() => {
                    this.$emit('changed', this.attachmentType);
                });
        } else {
            this.model.removeAttachmentType(this.attachmentType)
                .then(() => this.$emit('changed'));
        }
    }

    private refresh(): void {
        this.model.getEstimate()
            .then(estimate => {
                this.uploadedAttachments = [
                    ...(estimate.attachments.filter(attachment => attachment.type === this.attachmentType)),
                ];
            });
    }

    private translateType(type: AttachmentType): string {
        return this.$tc(`parameters.attachments.options.${type}`);
    }
}
